import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AthleteRegistration from './components/AthleteRegistration'
import AthletesList from './pages/AthletesList'
import AthleteDetail from './pages/AthleteDetail'
import DebugSupabase from './components/DebugSupabase'
import './index.css'

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<AthleteRegistration />} />
        <Route path="/register" element={<AthleteRegistration />} />
        <Route path="/athletes" element={<AthletesList />} />
        <Route path="/athletes/:id" element={<AthleteDetail />} />
        <Route path="/debug" element={<DebugSupabase />} />
      </Routes>
    </div>
  )
}

export default App
